import {Component, OnInit, Input, Optional, Self, ElementRef, ViewChild} from '@angular/core';
import {NgControl} from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import {BaseAnswerTypeComponent} from "../base-answer-type.component";
import {ComparableOperator, PosibleAnswer} from "../../../../models/form";

@Component({
  selector: 'app-select-multiple-input',
  templateUrl: './select-multiple-input.component.html',
  styleUrls: ['./select-multiple-input.component.scss']
})
export class SelectMultipleInputComponent extends BaseAnswerTypeComponent<number[]> implements OnInit {
  @Input() placeholder: string = '';
  @Input() label: string;
  @Input() filterEnabled: boolean = false;
  @Input() readonly: boolean;
  @ViewChild('selectFilterInput') selectFilterInput: ElementRef<HTMLInputElement>;

  filteredItemsData: PosibleAnswer[] = [];

  _items$: BehaviorSubject<PosibleAnswer[]>;
  get items(): PosibleAnswer[] {
    return this._items$.getValue();
  }
  @Input() set items(value: PosibleAnswer[]) {
    this._items$.next(value);
  }

  constructor(
    @Self()
    @Optional()
    ngControl?: NgControl,
  ) {
    super(ngControl);
    this._items$ = new BehaviorSubject<PosibleAnswer[]>([]);
  }

  ngOnInit() {
    this._items$.subscribe(value => this.filteredItemsData = value);

    if(this.filterEnabled) {
      this.ngControl.valueChanges.subscribe(value => {
        if(!value) {
          this.selectFilterInput.nativeElement.value = '';
          this.filteredItemsData = this.items;
        }
      })
    }
  }

  onFilterSelectKeyUp(event) {
    event.stopPropagation();
    let filter = event.target?.value.toLocaleLowerCase();
    this.filteredItemsData = this.items.filter(item => item.description.toLowerCase().includes(filter))
  }

  getItemDescription(id: number): string {
    const item = this.items.filter(x => x.id == id)[0];
    return item ? item.description : '';
  }


  AllowedOperators: {[K in ComparableOperator]: (target: number[]|null, value?: string) => boolean} = {
    [ComparableOperator.Equal]: (t: number[]|null, value: string) => {
      if (!t) return false;
      const ids = value.split(";").map(v => Number(v));
      if (t.length != ids.length) return false;
      return t.every(s => ids.includes(s));
    },
    [ComparableOperator.NotEqual]: (t, value: string) => {
      return !this.AllowedOperators[ComparableOperator.Equal](t, value);
    },
    [ComparableOperator.Contains]: (t, value: string) => t?.includes(Number(value)),
    [ComparableOperator.StartWith]: null,
    [ComparableOperator.EndWith]: null,
    [ComparableOperator.In]: (t, value: string) => {
      if (!t?.length) return false;
      const IDs = value.split(";").map(v => Number(v));
      return t.every(s => IDs.includes(s));
    },
    [ComparableOperator.GreaterThan]: (t, value) => t?.length > Number(value),
    [ComparableOperator.GreaterThanOrEqual]: (t, value) => t?.length >= Number(value),
    [ComparableOperator.LessThan]: (t, value) => t?.length < Number(value),
    [ComparableOperator.LessThanOrEqual]: (t, value) => t?.length <= Number(value),
    [ComparableOperator.IsNullOrEmpty]: (t) => !(t?.length),
    [ComparableOperator.NotIsNullOrEmpty]: (t) => !!t?.length,
    [ComparableOperator.Between]: null,
    [ComparableOperator.Empty]: null,
    [ComparableOperator.Completed]: null,
  }
}
